module.exports = __webpack_public_path__ + "static/soft-dev-2a1515d3f0aa86372984c9e61e1d47b8.svg";